import { useEffect, useState } from "react";

const Photo = () => {
	const [data, setData] = useState({
		image_count: 1,
		size: "",
	});

	// Each entry = { front: File|null, back: File|null }
	const [nidPairs, setNidPairs] = useState([{ front: null, back: null }]);

	const isNidSideBySide = data.size === "nid_side_by_side";

	const handleChange = (e) => {
		const { name, value } = e.target;
		setData((preData) => ({
			...preData,
			[name]: value,
		}));
	};

	// Handle file change for a specific pair and side (front/back)
	const handleNidFileChange = (pairIndex, side, e) => {
		const file = e.target.files[0] || null;
		setNidPairs((prev) => {
			const updated = [...prev];
			updated[pairIndex] = { ...updated[pairIndex], [side]: file };
			return updated;
		});
	};

	const addNidPair = () => {
		setNidPairs((prev) => [...prev, { front: null, back: null }]);
	};

	const removeNidPair = (index) => {
		setNidPairs((prev) => prev.filter((_, i) => i !== index));
	};

	useEffect(() => {
		console.log(data);
	}, [data]);

	const handleSubmit = (e) => {
		e.preventDefault();
		setData({ image_count: 1, size: "" });
		setNidPairs([{ front: null, back: null }]);
	};

	return (
		<div className="py-4 mb-8">
			<form
				onSubmit={handleSubmit}
				id="uploadForm"
				className="max-w-lg mx-auto"
			>
				<div>
					{/* Navigation Buttons */}
					<div className="flex justify-end mb-4">
						<a
							className="btn-primary bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded mx-2"
							href="/multiple"
						>
							Multiple Image
						</a>
						<a
							className="btn-success bg-green-500 hover:bg-green-700 text-white py-2 px-4 rounded"
							href="https://www.remove.bg/"
						>
							Background Remove
						</a>
					</div>

					{/* Form Inputs */}
					<div className="space-y-4">
						{/* Select Size */}
						<div>
							<label className="block text-gray-700 font-medium mb-2">
								Set Size
							</label>
							<select
								className="block w-full border border-gray-300 rounded px-3 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
								id="size"
								required
								name="size"
								value={data.size}
								onChange={handleChange}
							>
								<option value="" disabled>-- Select a size --</option>
								<option value="passport">Passport Size</option>
								<option value="landscape">
									Passport Landscape (4)
								</option>
								<option value="stamp">Stamp Size</option>
								<option value="2x4">
									2x4 in (NGO Combine Photo)
								</option>
								<option value="2x2">
									2x2 in (Indian Visa Size)
								</option>
								<option value="nid">NID (2 Image)</option>
								<option value="nid_side_by_side">
									NID (Front | Back)
								</option>
								<option value="nid_combined">
									NID Combined (1 Image)
								</option>
								<option value="mrp">MRP Passport</option>
								<option value="bordered">
									A4 with 0.5 Inch Border
								</option>
								<option value="3R">
									3R Photo (Album Size)
								</option>
							</select>
						</div>

						{/* NID Side-by-Side: pair uploaders */}
						{isNidSideBySide ? (
							<div className="space-y-3">
								<label className="block text-gray-700 font-medium">
									NID Image Pairs (Front &amp; Back)
								</label>

								{nidPairs.map((pair, index) => (
									<div
										key={index}
										className="border border-gray-300 rounded p-3 space-y-2 bg-gray-50"
									>
										<div className="flex items-center justify-between mb-1">
											<span className="text-sm font-semibold text-gray-600">
												Pair {index + 1}
											</span>
											{nidPairs.length > 1 && (
												<button
													type="button"
													onClick={() => removeNidPair(index)}
													className="text-red-500 hover:text-red-700 text-sm font-medium"
												>
													✕ Remove
												</button>
											)}
										</div>

										{/* Front */}
										<div>
											<label className="block text-xs text-gray-500 mb-1">
												Front side
											</label>
											<input
												type="file"
												accept="image/*"
												className="block w-full border border-gray-300 rounded px-3 py-1.5 text-sm focus:ring focus:ring-blue-500 focus:outline-none"
												onChange={(e) => handleNidFileChange(index, "front", e)}
												required
											/>
											{pair.front && (
												<p className="text-xs text-green-600 mt-1">
													✓ {pair.front.name}
												</p>
											)}
										</div>

										{/* Back */}
										<div>
											<label className="block text-xs text-gray-500 mb-1">
												Back side
											</label>
											<input
												type="file"
												accept="image/*"
												className="block w-full border border-gray-300 rounded px-3 py-1.5 text-sm focus:ring focus:ring-blue-500 focus:outline-none"
												onChange={(e) => handleNidFileChange(index, "back", e)}
												required
											/>
											{pair.back && (
												<p className="text-xs text-green-600 mt-1">
													✓ {pair.back.name}
												</p>
											)}
										</div>
									</div>
								))}

								{/* Add pair button */}
								<button
									type="button"
									onClick={addNidPair}
									className="w-full border-2 border-dashed border-blue-400 text-blue-500 hover:bg-blue-50 py-2 px-4 rounded font-medium transition-colors"
								>
									+ Add Another Pair
								</button>
							</div>
						) : (
							/* Default file input for all other sizes */
							<div>
								<label className="block text-gray-700 font-medium mb-2">
									Select one or more Images
								</label>
								<input
									className="block w-full border border-gray-300 rounded px-3 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
									type="file"
									id="imageUpload1"
									accept="image/*"
									multiple
									name="image"
									onChange={handleChange}
									required
								/>
							</div>
						)}

						{/* Image Count */}
						<div>
							<label className="block text-gray-700 font-medium mb-2">
								Set Count
							</label>
							<input
								className="block w-full border border-gray-300 rounded px-3 py-2 focus:ring focus:ring-blue-500 focus:outline-none"
								min={1}
								max={20}
								type="number"
								id="imageCount1"
								name="image_count"
								value={data?.image_count || ""}
								onChange={handleChange}
								required
							/>
						</div>

						{/* Submit Button */}
						<div>
							<button
								className="w-full bg-green-500 hover:bg-green-700 text-white py-2 px-4 rounded"
								type="submit"
							>
								Submit
							</button>
						</div>
					</div>
				</div>
			</form>
		</div>
	);
};

export default Photo;
